import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useCpaTeamProfile(filters) {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);

  const params = {
    policy_plan_id: filters.policyPlanId,
    team_id: filters.teamId,
    cycle_id: filters.cycleId,
  };

  useEffect(() => {
    setLoading(true);

    axios
      .get(routes.api.managers.dashboard.cpa_team_profile, { params })
      .then((response) => {
        setData(response.data.data);
        setLoading(false);
      });
  }, [filters.policyPlanId, filters.teamId, filters.cycleId]);

  return { data, loading };
}
